import React, {useState, useContext} from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";

import {blue50, blue500, grey300, greyishBlue600, greyishBlue900} from "assets/jss/main";

import {SidebarContext} from "../../../SidebarContext";

SidebarItem.propTypes = {
    to: PropTypes.string,
    selected: PropTypes.bool,
    icon: PropTypes.any,
    endAdornment: PropTypes.any,
    style: PropTypes.object,
    isTopLevel: PropTypes.bool
};

function SidebarItem({
    to,
    selected = false,
    icon = null,
    endAdornment = null,
    style = {},
    isTopLevel = false,
    onClick = () => {},
    ...props
}) {
    const {closeSidebar} = useContext(SidebarContext);
    const [isHovered, setIsHovered] = useState(false);

    const content = (
        <div
            onClick={(e) => {
                onClick(e);
                if (to) {
                    closeSidebar();
                }
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                color: isTopLevel ? greyishBlue900 : greyishBlue600,
                fontWeight: 600,
                fontSize: '14px',
                padding: '8px',
                paddingLeft: isTopLevel ? '8px' : '36px',
                cursor: 'pointer',
                borderRadius: '8px',
                background: isHovered ? grey300 : 'white',
                ...selected && {
                    background: blue50,
                    color: blue500,
                },
                ...style
            }}
        >
            <div style={{
                display: 'flex',
                alignItems: 'center'
            }}>
                {icon && (
                    <div style={{
                        marginRight: '8px',
                        width: '20px',
                        height: '20px'
                    }}>
                        {icon}
                    </div>
                )}
                <div>
                    {props.children}
                </div>
            </div>
            {endAdornment && (
                <div>
                    {endAdornment}
                </div>
            )}
        </div>
    );

    if (to) {
        return (
            <Link to={to} style={{ textDecoration: 'none' }}>
                {content}
            </Link>
        )
    }

    return content;
}

export default SidebarItem;
